export const CURRENCY_RATIO = 1000;
export const currencyIsoCodes = Object.freeze({
    GBP: 'GBP'
});

export default class CurrencyHelper {
    static convertToPounds(price) {
        if (typeof price !== 'number') {
            return '£';
        }
        const amount = price / CURRENCY_RATIO;
        const output = amount % 1 === 0 ? amount.toString() : amount.toFixed(2);
        return `£${output}`;
    }

    static getMinusPounds(origin, poundsCount) {
        return origin - poundsCount * CURRENCY_RATIO;
    }

    static getTotalMcFromTotal(total, masterCardDiscount = 0) {
        return Math.max(this.getMinusPounds(total, masterCardDiscount), 0);
    }
}
